export default {
  'login.signIn': 'Sign in',
  'login.signOut': 'Sign out',
  'login.signUp': 'Sign up',

  'login.enter': 'Enter',
  'login.back': 'Back',
  'login.continue': 'Continuar',

  'login.title.recover': 'Recover your password',
  'login.title.create': 'Create Account',

  'login.error': 'Error',
  'login.error.invalid': 'Invalid credencials',
  'login.error.email': 'Email not valid',
  'login.error.emailNotFound': 'Email not found.',
  'login.error.tooManyAttempts': 'Too many attempts. Please try again in a minute.',
  'login.error.nameNotValid': 'The name field is required',
  'login.error.emailNotValid': 'The email field is required',
  'login.error.passwordNotValid': 'Password must be 6 characters or more',
  'login.error.passwordsNotEqual': 'Passwords do not match',

  'login.success.recovered': 'The link to change your password has been sent to your email.',
  'login.success.created': 'A nova conta foi criada com sucesso.',

  'login.label.name': 'Name',
  'login.label.password': 'Password',
  'login.label.confirmation': 'Confirm the new password',
  'login.action.linkedin': 'Continue with LinkedIn',

  'login.text.login': 'or sign in normally',
  'login.text.newAccount': 'Don\'t havet an account yet? Create one.',
  'login.text.forgottenLink': 'Forgot your password?',
};



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/intl/en.js
 **/